import { render, staticRenderFns } from "./UserForm.vue?vue&type=template&id=71233e1e&"
import script from "./UserForm.vue?vue&type=script&lang=js&"
export * from "./UserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('71233e1e', component.options)
    } else {
      api.reload('71233e1e', component.options)
    }
    module.hot.accept("./UserForm.vue?vue&type=template&id=71233e1e&", function () {
      api.rerender('71233e1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Pages/Users/UserForm.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Users/UserForm.vue
// module id = 8bCe
// module chunks = 0